import React from "react";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppButton } from "@/components/widgets/WhatsAppButton";
import { ChatWidget } from "@/components/widgets/ChatWidget";

export function SiteLayout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
      <ChatWidget />
    </div>
  );
}
